import { AudienceSource, AudienceSourceFee } from '../types/AudienceSource';
import {
    DspAudience as DspAudienceSource,
    DspAudienceSourceCategoryGroup,
    DspAudienceFee as DspAudienceSourceFee,
} from '../types/DspAudience';

const DspAudienceSourceUtils = {
    toAudienceSourceFee: (dspAudienceSourceFee: DspAudienceSourceFee): AudienceSourceFee => {
        return {
            amount: dspAudienceSourceFee.amount,
            currency: dspAudienceSourceFee.currency,
            feeCalculationType: dspAudienceSourceFee.feeCalculationType,
            impressionSupplyType: dspAudienceSourceFee.impressionSupplyType,
            scale: dspAudienceSourceFee.scale,
        };
    },
    toAudienceSource: (dspAudienceSource: DspAudienceSource): AudienceSource => {
        return {
            audienceId: dspAudienceSource.audienceId,
            audienceName: dspAudienceSource.audienceName,
            description: dspAudienceSource.description,
            category: dspAudienceSource.category,
            subCategory: dspAudienceSource.subCategory,
            status: dspAudienceSource.status,
            providerId: dspAudienceSource.providerId,
            forecasts: {
                inventoryForecasts: {
                    all: {
                        dailyReach: {
                            lowerBoundInclusive: dspAudienceSource.dailyReachLowerBoundInclusive,
                            upperBoundExclusive: dspAudienceSource.dailyReachUpperBoundExclusive,
                        },
                        dailyImpressions: {
                            lowerBoundInclusive: dspAudienceSource.dailyImpressionsLowerBoundInclusive,
                            upperBoundExclusive: dspAudienceSource.dailyImpressionsUpperBoundExclusive,
                        },
                    },
                },
            },
            fees: dspAudienceSource.fees.length
                ? dspAudienceSource.fees.map((model: DspAudienceSourceFee) =>
                      DspAudienceSourceUtils.toAudienceSourceFee(model)
                  )
                : [],
        };
    },
    toDspAudienceSourceCategoryGroups: (targets: DspAudienceSource[]): DspAudienceSourceCategoryGroup[] => {
        const groups: DspAudienceSourceCategoryGroup[] = [];
        const group: { [key: string]: DspAudienceSourceCategoryGroup } = {};

        if (targets) {
            targets.forEach((target: DspAudienceSource) => {
                // let code: string =
                //     target.category && target.subCategory ? `${target.category} > ${target.subCategory}` : target.category;
                let code: string = target.category;
                if (code) {
                    if (!group[code]) {
                        group[code] = new DspAudienceSourceCategoryGroup();
                        group[code].category = code;
                        groups.push(group[code]);
                    }
                    group[code].audienceSources.push(target);
                }
            });
        }

        return groups;
    },
};

export default DspAudienceSourceUtils;
